export default __webpack_public_path__ + "9e74c4386a69e3245cf14265c580c12e.png";